// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("PendingPurchase", {
  stripeSessionId: __t.string(),
  userId: __t.u64(),
  purchaseType: __t.string(),
  packId: __t.option(__t.string()),
  tierId: __t.option(__t.u32()),
  createdAt: __t.u64(),
  fulfilled: __t.bool(),
});


